import type { ReactNode } from "react";

type TextLike = string | number | boolean | null | undefined;

function isTextLike(value: unknown): value is TextLike {
    return (
        value === null ||
        value === undefined ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
    );
}

/**
 * Join JSX text children into one string so the typographic contract applies
 * to `{key}: {value}` as it does to a literal. Elements pass through
 * untouched (`null` result). `null`, `undefined`, and booleans render as
 * nothing, as React does.
 */
export function coerceBadgeLabel(children: ReactNode): string | null {
    if (typeof children === "string" || typeof children === "number") return String(children);
    if (Array.isArray(children) && children.every(isTextLike)) {
        return children
            .filter((part): part is string | number => typeof part === "string" || typeof part === "number")
            .map(String)
            .join("");
    }
    return null;
}
